export default __webpack_public_path__ + "static/media/bg-stars.166881a1.svg";